import { TUnreads, TDirectMessage, TLastMessage } from '../types/direct-chat';
import { TPatient } from '../types/patients';

export const getUnreads = (): TUnreads => {
  const unreadsString = localStorage.getItem('DIRECT_UNREADS');
  if (unreadsString) {
    const unreadsObj: TUnreads = JSON.parse(unreadsString);
    return unreadsObj;
  }
  return {};
};

/*
    invalid unreads are messages from non-patients
*/
export const deleteInvalidUnreads = (unreads: TUnreads, patients: TPatient[]): TUnreads => {
  const newUnreads: TUnreads = {};
  const jabberIds = patients.map((p) => p.from.jabberId);
  for (const key in unreads) {
    if (jabberIds.includes(key)) {
      newUnreads[key] = unreads[key];
    }
  }
  saveUnreads(newUnreads);
  return newUnreads;
};

export const saveUnreads = (unreads: TUnreads) => {
  localStorage.setItem('DIRECT_UNREADS', JSON.stringify(unreads));
};

export const incrementUnreadForContact = (contactJid: string) => {
  const unreadsString = localStorage.getItem('DIRECT_UNREADS');
  let unreadsObj: any = {};
  let unreads = 0;

  if (unreadsString) {
    unreadsObj = JSON.parse(unreadsString);
    unreads = unreadsObj[contactJid] || 0;
  }

  unreadsObj[contactJid] = unreads + 1;
  localStorage.setItem('DIRECT_UNREADS', JSON.stringify(unreadsObj));
};

/**
 * direct chat might received dublicated messages,
 * which might break unreads count
 * @param message
 */
export const isDuplicate = (message: TDirectMessage): boolean => {
  // @ts-ignore
  const cachedMessages: string[] = window.cachedMessages || [];
  const isDublicate = cachedMessages.includes(message.uuid);
  cachedMessages.push(message.uuid);
  // @ts-ignore
  window.cachedMessages = cachedMessages;
  return isDublicate;
};

export const sortLastMessages = (messages: TLastMessage[]): TLastMessage[] =>
  messages.sort((a, b) => {
    if (a.stamp && b.stamp) {
      // @ts-ignore
      return new Date(b.stamp) - new Date(a.stamp);
    }
    if (a.stamp && b.stamp === '') {
      return -1;
    }
    if (a.stamp === '' && b.stamp) {
      return 1;
    }
    return 0;
  });
